module.exports = __webpack_public_path__ + "static/media/marks.2a91702b.svg";